import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import rootReducer from './combineReducers';
import rootSaga from './rootSaga';
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

// Create the Saga middleware
const sagaMiddleware = createSagaMiddleware();

// Configure Redux Persist
// const persistConfig = {
//   key: 'root',
//   storage,
// }

// Wrap the root reducer with Redux Persist
// const persistedReducer = persistReducer(persistConfig, rootReducer)

// Create the Redux store
// const store = configureStore({
//   reducer: persistedReducer,
//   middleware: [sagaMiddleware], // Include Saga middleware
// });

const store = configureStore({
  reducer: rootReducer,
  middleware: [sagaMiddleware],
});

// Run the root saga
sagaMiddleware.run(rootSaga);

// Create the Redux Persistor
// const persistor = persistStore(store);

// Export the store and persistor
// export default { store, persistor };
export default store;
